jQuery(function($) {

    // Close fancybox modal from iframe button
    $('.popin .btn-close').each(function(e) {
        jQuery.fancybox.getInstance().close();
    });

});
